/**
 * Patches console.* to forward entries into the bug-report capture buffer.
 */

import { shouldCaptureConsole } from './captureConfig'
import { captureBufferPush } from './captureBuffer'

let installed = false

type ConsoleFn = (...args: unknown[]) => void

function formatArgs(args: unknown[]): string {
  return args
    .map((a) => {
      if (typeof a === 'string') return a
      try {
        return JSON.stringify(a)
      } catch {
        return String(a)
      }
    })
    .join(' ')
}

function wrap(level: string, original: ConsoleFn): ConsoleFn {
  return (...args: unknown[]) => {
    if (shouldCaptureConsole() && level !== 'debug') {
      try {
        captureBufferPush('console', level, formatArgs(args).slice(0, 4000))
      } catch {
        /* ignore */
      }
    }
    original.apply(console, args)
  }
}

export function installConsoleCapture(): void {
  if (installed || typeof window === 'undefined') return
  installed = true
  const c = console
  c.log = wrap('info', c.log.bind(c))
  c.info = wrap('info', c.info.bind(c))
  c.warn = wrap('warn', c.warn.bind(c))
  c.error = wrap('error', c.error.bind(c))
  // debug excluded by default in wrap()
  c.debug = wrap('debug', c.debug.bind(c))
}
